import React from 'react'
import IMG from "./node.png"
function NodeLogo() {
  return (
    <>
<img src={IMG} style={{width:"200px",height:"150px" }} alt='node' />
    </>
  )
}

export default NodeLogo